import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { LocalCurrencyNote } from './LocalCurrencyNote';
import { useCountdown } from '../hooks/useCountdown';
import { markCheckoutStarted } from '../hooks/useExitIntent';
import { CheckCircle2, AlertTriangle, PlayCircle, BookOpen } from 'lucide-react';
import { PRODUCTS } from './MetaPixel';
export const ProductTomos = () => {
  const phases = [{
    name: 'Fase 1 — Los Cimientos',
    modules: [{
      n: 1,
      title: 'Fundamentos de la Colorimetría',
      time: '~40 min'
    }, {
      n: 2,
      title: 'Decoloración Uniforme',
      time: '~35 min'
    }, {
      n: 3,
      title: 'Neutralizando Tonos Amarillos',
      time: '~30 min'
    }]
  }, {
    name: 'Fase 2 — Dominio de Platinados',
    modules: [{
      n: 4,
      title: 'Global en Platinado',
      time: '~45 min'
    }, {
      n: 5,
      title: 'Global Blanco',
      time: '~50 min'
    }, {
      n: 6,
      title: 'Gris Claro Paso a Paso',
      time: '~40 min'
    }]
  }, {
    name: 'Fase 3 — Técnicas de Diseño',
    modules: [{
      n: 7,
      title: 'Mechas Platinadas',
      time: '~38 min'
    }, {
      n: 8,
      title: 'Mechas Primavera/Verano',
      time: '~35 min'
    }, {
      n: 9,
      title: 'Global + Cúspide',
      time: '~42 min'
    }, {
      n: 10,
      title: 'Franjas Paso a Paso',
      time: '~40 min'
    }, {
      n: 11,
      title: 'Fórmulas y Colores Fantasías',
      time: '~45 min'
    }]
  }, {
    name: 'Fase 4 — Técnicas Avanzadas Roots',
    modules: [{
      n: 12,
      title: 'Técnica Roots Paso a Paso',
      time: '~50 min'
    }, {
      n: 13,
      title: 'Platinado con Técnica Root',
      time: '~48 min'
    }, {
      n: 14,
      title: 'Técnicas Roots Brasileñas',
      time: '~45 min'
    }, {
      n: 15,
      title: 'Peinados Modernos',
      time: '~35 min'
    }]
  }];
  const manuals = [{
    emoji: '🟡',
    title: 'Manual 1 — Fundamentos Pro',
    pages: '~120 páginas',
    extra: '+ Tablas de neutralización',
    color: 'bg-[#EAB308]',
    borderColor: 'border-t-[#EAB308]'
  }, {
    emoji: '🟠',
    title: 'Manual 2 — Análisis y Paletas Masculinas',
    pages: '~110 páginas',
    extra: '+ Fichas de diagnóstico visual',
    color: 'bg-[#EA580C]',
    borderColor: 'border-t-[#EA580C]'
  }, {
    emoji: '🔴',
    title: 'Manual 3 — De la Teoría a la Práctica',
    pages: '~125 páginas',
    extra: '+ Fórmulas gramo a gramo exactas',
    color: 'bg-[#DC2626]',
    borderColor: 'border-t-[#DC2626]'
  }, {
    emoji: '🟣',
    title: 'Manual 4 — Técnicas y Diseños de Colorimetría',
    pages: '~120 páginas',
    extra: '+ Biblioteca de diseños',
    color: 'bg-[#8B5CF6]',
    borderColor: 'border-t-[#8B5CF6]'
  }];
  const features = ['Objetivo claro y visible para dominar ese aspecto', 'Conceptos conectados y organizados progresivamente', 'Técnicas listas para imprimir y aplicar en sesión', 'Tablas y fórmulas de consulta permanente', 'Material de referencia — siempre en tu celular o impreso', 'Herramientas complementarias ya integradas', 'Un sistema coherente — NADA disperso'];
  const featureChips = ['✅ Domina el sistema de colorimetría masculina completo', '✅ TODO conectado y en un solo lugar', '✅ Técnicas probadas listas para aplicar', '✅ Fórmulas exactas gramo a gramo', '✅ 475+ páginas + 15 horas de video', '✅ Imprimible — Tenlo siempre en tu local'];
  return <Section className="bg-bg-base !pt-3 md:!pt-8" data-id="element-19" data-mp="1ebtmimsjip9r">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-20" data-mp="19ds3g1v46pya">
        {/* Gold trust pill */}
        <div className="flex justify-center mb-4 md:mb-5" data-id="element-21" data-mp="19fv1n96f7pe3">
          <span className="inline-flex items-center gap-1.5 font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] px-3 py-1 md:px-3.5 md:py-1.5 rounded-full bg-brandGold text-[#14100A]" style={{
          boxShadow: '0 0 20px rgba(212,162,76,0.35)'
        }} data-id="element-22" data-mp="14m0dntjs8o97">
            🏆 El Sistema Completo de Colorimetría Masculina
          </span>
        </div>

        <h2 className="font-display font-bold uppercase text-txt-primary mb-3 md:mb-4 md:text-[36px] text-[22px] leading-[1.25] tracking-[0.5px]" data-id="element-23" data-mp="1cuwezc9fdpok">
          🎨 MEGAPACK COLORIMETRÍA{' '}
          <span className="text-brandGold" data-id="element-24" data-mp="13ty90offf83c">LISTA™</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-25" data-mp="13vrdbx2khg86">
          15 Módulos en Video + 4 Manuales PDF + 5 Bonos — 475+ páginas · TODO
          organizado · Imprimible y accesible.
        </p>
      </FadeIn>

      {/* Module strip */}
      <FadeIn delay={0.2} className="mb-5 md:mb-8" data-id="element-26" data-mp="20jpdnghfmbmv">
        <div className="flex flex-wrap justify-center gap-1.5 md:gap-2.5 px-2 md:px-0" data-id="element-27" data-mp="1mt2g3rneqrsd">
          {Array.from({
          length: 15
        }).map((_, i) => <div key={i} className="w-[54px] md:w-[62px] h-[52px] md:h-[62px] rounded-md bg-bg-card border border-brandGold/35 flex flex-col items-center justify-center gap-0.5 text-center transition-transform hover:-translate-y-1" data-id="element-28" data-mp="1qsulxwlf2ju1" data-mpi={i}>
              <PlayCircle size={13} className="text-brandGold" aria-hidden="true" data-id="element-29" data-mp="7vq0x4l7suii" />
              <span className="font-sans font-bold uppercase tracking-[0.5px] text-[7.5px] md:text-[8.5px] leading-tight text-txt-body" data-id="element-30" data-mp="7tn3hzhqfz3r">
                Módulo {i + 1}
              </span>
            </div>)}
        </div>
        <div className="text-center mt-3 md:mt-4" data-id="element-31" data-mp="cmg88nd7b7fu">
          <span className="inline-block bg-brandGold text-[#14100A] font-sans font-bold uppercase tracking-[1.5px] text-[9.5px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full" data-id="element-32" data-mp="cmyaq1qgihw7">
            15 MÓDULOS EN VIDEO + 4 MANUALES COMPLETOS
          </span>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} className="mb-8 md:mb-12" data-id="element-33" data-mp="3v1h1poacubjh">
        <div className="flex flex-wrap justify-center gap-x-1 gap-y-1 md:gap-x-1.5 md:gap-y-1.5 max-w-3xl mx-auto" data-id="element-34" data-mp="3q1cfriqogolv">
          {featureChips.map((chip, i) => <span key={i} className="bg-brandGold/10 text-brandGold border border-brandGold/30 px-1.5 py-0.5 md:px-2 md:py-1 rounded-full font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[10px] whitespace-nowrap" data-id="element-35" data-mp="1a8vlte2ibky4" data-mpi={i}>
              {chip}
            </span>)}
        </div>
      </FadeIn>

      <FadeIn delay={0.35} className="text-center mb-5 md:mb-7" data-id="element-36" data-mp="1hbk0ym8l6mp2">
        <div className="inline-flex items-center gap-2 bg-bg-card border border-brandGold/30 rounded-full px-4 py-1.5 md:px-5 md:py-2" data-id="element-37" data-mp="1mc7y7pnerzrq">
          <span className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] md:text-[13px] text-brandGold" data-id="element-38" data-mp="1rat15wu1oxjv">
            📦 Lo que recibes:
          </span>
        </div>
      </FadeIn>

      {/* Video curriculum */}
      <FadeIn delay={0.4} className="mb-10 md:mb-14" data-id="element-39" data-mp="13m02vtpyadm3">
        <h3 className="font-display font-bold uppercase text-[18px] md:text-[26px] leading-[1.2] tracking-[0.5px] text-txt-primary text-center mb-5 md:mb-8" data-id="element-40" data-mp="13l898ofwypyg">
          🎬 Entrenamiento en video{' '}
          <span className="text-brandGold" data-id="element-41" data-mp="awt5wz659w2y">(15 Módulos)</span>
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5 max-w-4xl mx-auto" data-id="element-42" data-mp="fvm7bt85pwmr">
          {phases.map(phase => <div key={phase.name} className="bg-bg-card rounded-[16px] border border-line p-4 md:p-5" data-id="element-43" data-mp="2t5nmby1h2inq">
              <p className="font-display font-bold uppercase tracking-[1px] text-[12px] md:text-[14px] text-brandGold mb-3" data-id="element-44" data-mp="2p6evb0xtgyvv">
                {phase.name}
              </p>
              <ul className="divide-y divide-line" data-id="element-45" data-mp="2f7fmnid1x38v">
                {phase.modules.map(mod => <li key={mod.n} className="flex items-center gap-2.5 py-2" data-id="element-46" data-mp="2a7t8n6pefiz0">
                    <span className="font-display font-bold text-[13px] md:text-[15px] text-txt-faint w-6 shrink-0" data-id="element-47" data-mp="2a9xmohh0hyd0">
                      {mod.n.toString().padStart(2, '0')}
                    </span>
                    <span className="font-sans text-[12.5px] md:text-[14px] leading-snug text-txt-body flex-1 min-w-0" data-id="element-48" data-mp="21d53rhnqk3aq">
                      {mod.title}
                    </span>
                    <span className="font-sans font-bold text-[10px] md:text-[11px] text-txt-muted shrink-0" data-id="element-49" data-mp="1rgjx6rw2ik4s">
                      {mod.time}
                    </span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </FadeIn>

      {/* Manuals */}
      <FadeIn delay={0.45} className="mb-10 md:mb-14" data-id="element-50" data-mp="3fcq5jnfo59h4">
        <h3 className="font-display font-bold uppercase text-[18px] md:text-[26px] leading-[1.2] tracking-[0.5px] text-txt-primary text-center mb-5 md:mb-8" data-id="element-51" data-mp="31e8lq0svwh4h">
          📘 Manuales PDF{' '}
          <span className="text-brandGold" data-id="element-52" data-mp="36f5zm16v2p06">(4 Tomos — 475+ páginas)</span>
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5 max-w-4xl mx-auto" data-id="element-53" data-mp="2rmccpup9f6lh">
          {manuals.map(manual => <div key={manual.title} className={`bg-bg-card rounded-[16px] md:rounded-[20px] p-4 md:p-6 border-x border-b border-x-line border-b-line border-t-[3px] ${manual.borderColor}`} data-id="element-54" data-mp="2inqwi679g3nv">
              <div className="flex items-start gap-2.5 md:gap-3" data-id="element-55" data-mp="2nkha8mvlen64">
                <div className="text-2xl md:text-3xl shrink-0" aria-hidden="true" data-id="element-56" data-mp="28q4ehaunzvzo">
                  {manual.emoji}
                </div>
                <div className="min-w-0" data-id="element-57" data-mp="2dqifi8xum5o7">
                  <h4 className="font-sans font-bold text-[14px] md:text-[17px] text-txt-primary leading-snug mb-1.5 md:mb-2" data-id="element-58" data-mp="1u3xa22bc9qzm">
                    {manual.title}
                  </h4>
                  <div className="flex flex-wrap gap-1.5" data-id="element-59" data-mp="241l7x148rem0">
                    <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-brandGold bg-brandGold/10 px-2 py-0.5 rounded" data-id="element-60" data-mp="23yp6v3x3k9tc">
                      {manual.pages}
                    </span>
                    <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-txt-muted bg-white/5 px-2 py-0.5 rounded" data-id="element-61" data-mp="290ehwjkbknhf">
                      {manual.extra}
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </FadeIn>

      <FadeIn delay={0.5} data-id="element-62" data-mp="2wqsd2iy7b2g8">
        <div className="bg-bg-card rounded-[20px] p-5 md:p-10 border border-line max-w-4xl mx-auto" data-id="element-63" data-mp="2wpz2t8019utc">
          <h3 className="font-sans font-bold text-lg md:text-xl text-center text-txt-primary leading-snug mb-5 md:mb-8 flex items-center justify-center gap-2" data-id="element-64" data-mp="2rsh40afqcvz2">
            <BookOpen size={20} className="text-brandGold" aria-hidden="true" data-id="element-65" data-mp="2m6kb1kycmcey" />
            Cada manual incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2.5 md:gap-4" data-id="element-66" data-mp="2h88vqupab9pc">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-67" data-mp="2d419d46au5ua" data-mpi={i}>
                <CheckCircle2 className="text-success shrink-0 mt-0.5 w-4 h-4 md:w-5 md:h-5" data-id="element-68" data-mp="39vv0w7e5umeb" />
                <span className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-69" data-mp="34ylel0m2iqup">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="mt-6 md:mt-8 text-center" data-id="element-70" data-mp="2vvka14cup7t5">
            <p className="font-sans font-bold text-base md:text-xl text-brandGold leading-snug" data-id="element-71" data-mp="2vyyfilgt9x4t">
              Abres el MEGAPACK, buscas lo que necesitas, lo imprimes si
              quieres, ves el video de referencia, y lo aplicas. Así de simple.
              TODO organizado. NADA disperso.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    icon: '🎨',
    title: 'Cartas de Color Masculinas (12 Paletas)',
    desc: 'Una para cada tipo de cliente. Imprimibles. Listas para usar como herramienta de venta en la silla.',
    value: 'USD $9',
    image: 'https://cdn.magicpatterns.com/uploads/jp4BHjGt1Ao6b3QQtsZsur/bono_1.webp'
  }, {
    num: '02',
    icon: '🇦🇷',
    title: 'Kit de Abastecimiento de Insumos (Marcas Reales)',
    desc: 'Nov, Issue, Fidelité, Schwarzkopf... Exactamente qué comprar, dónde y cuánto cuesta. La guía que te ahorra años de error.',
    value: 'USD $14',
    image: 'https://cdn.magicpatterns.com/uploads/1tHXueVXXLQSELBTV82b69/bono_2.webp'
  }, {
    num: '03',
    icon: '📋',
    title: 'Fichas Profesionales de Diagnóstico',
    desc: 'Registra cada cliente, diagnóstico, fórmula y resultado. Tenlo impreso. Tu sistema administrativo en papel.',
    value: 'USD $10',
    image: 'https://cdn.magicpatterns.com/uploads/rEXxahmnd5StBNzD3eCcrc/bono_3.webp'
  }, {
    num: '04',
    icon: '🎯',
    title: 'Guía de Combinaciones Visuales',
    desc: '100+ combinaciones de color para mostrar al cliente. Inspírate o copia. Listo para usar.',
    value: 'USD $12',
    image: 'https://cdn.magicpatterns.com/uploads/kdfga7K1WNEQoSC3MQapUH/Bono_4_nuevo.webp'
  }, {
    num: '05',
    icon: '🔥',
    title: 'Kit Profesional del Asesor de Color',
    desc: 'Checklists de seguridad, protocolos de emergencia, agenda de sesiones, registro de trabajos. TODO lo que necesitas para profesionalizarte.',
    value: 'USD $12',
    image: 'https://cdn.magicpatterns.com/uploads/5NkpdiA9ccM9zaZN6Q2nt4/bono_5.webp'
  }];
  return <Section className="bg-bg-alt" data-id="element-72" data-mp="17cyhkaubl9wv">
      <FadeIn className="text-center mb-8 md:mb-14" data-id="element-73" data-mp="179ub16tdu231">
        <h2 className="font-display font-bold uppercase md:text-[40px] text-txt-primary mb-2 md:mb-4 text-[26px] tracking-[0.5px]" data-id="element-74" data-mp="12dvegvxwhdrj">
          + 5 BONOS <span className="text-brandGold" data-id="element-75" data-mp="1lwj52t4v7n21">EXCLUSIVOS</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-76" data-mp="1qwdu0r52y2kg">
          Materiales listos para imprimir — sin costo extra
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-77" data-mp="1gy7vmjihfekc">
        {bonuses.map((bono, i) => <FadeIn key={bono.num} delay={Math.min(i * 0.05, 0.2)} data-id="element-78" data-mp="136jnerbcta8n" data-mpi={i}>
            <article className="bg-bg-card rounded-[16px] border border-line border-l-[3px] border-l-brandGold h-full overflow-hidden flex gap-3 p-3 md:gap-4 md:p-4" data-id="element-79" data-mp="17z4c5efekx5b">
              <img src={bono.image} alt={`Portada del bono ${bono.num}: ${bono.title}`} loading="lazy" decoding="async" width={128} height={171} className="w-24 self-start aspect-[3/4] shrink-0 rounded-[10px] object-cover border border-white/10 md:w-32" data-id="element-80" data-mp="y91akpu7uavd" />
              <div className="min-w-0 flex flex-1 flex-col" data-id="element-81" data-mp="p71v41yuneuj">
                <div className="flex items-center justify-between gap-2 mb-1.5" data-id="element-82" data-mp="h86w97tpsh39">
                  <div className="flex items-center gap-1.5" data-id="element-83" data-mp="c8kh2subsqrt">
                    <span className="text-lg md:text-xl" data-id="element-84" data-mp="c93ym8g2dd5b">🎁</span>
                    <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandGold" data-id="element-85" data-mp="7h2g44sayq6u">
                      BONO {bono.num}
                    </span>
                  </div>
                  <span className="text-lg md:text-xl" aria-hidden="true" data-id="element-86" data-mp="3uncy22z9qrks">{bono.icon}</span>
                </div>
                <h3 className="font-sans font-bold text-[13.5px] md:text-[15px] text-txt-primary leading-snug mb-1 md:mb-1.5" data-id="element-87" data-mp="3plvzwf865j7w">
                  {bono.title}
                </h3>
                <p className="font-sans text-[12px] md:text-[13.5px] leading-[1.45] md:leading-[1.55] text-txt-body mb-2.5 md:mb-3" data-id="element-88" data-mp="3gnu186bwr2ns">
                  {bono.desc}
                </p>
                <div className="mt-auto pt-2 md:pt-2.5 border-t border-line flex items-center justify-between gap-2" data-id="element-89" data-mp="1euw1dqjpr9tc">
                  <span className="font-sans font-normal text-[12px] md:text-[14px] line-through text-danger" data-id="element-90" data-mp="2wrzeul827lhc">
                    {bono.value}
                  </span>
                  <span className="bg-success text-white font-sans font-bold uppercase tracking-[1px] text-[8.5px] md:text-[10px] px-2 py-0.5 rounded-full" data-id="element-91" data-mp="36j3tfjttp4bn">
                    GRATIS
                  </span>
                </div>
              </div>
            </article>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="text-center bg-bg-card p-5 md:p-8 rounded-[20px] border border-line max-w-2xl mx-auto" data-id="element-92" data-mp="2iszwtwf1y4u5">
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body mb-2" data-id="element-93" data-mp="2mttew95tcpf4">
          Valor total de los 5 Bonos
        </p>
        <p className="font-sans font-normal text-[16px] md:text-[18px] line-through text-danger mb-2" data-id="element-94" data-mp="2rrl7z6i72hkw">
          USD $57
        </p>
        <p className="font-display font-bold text-[20px] md:text-[36px] leading-[1.15] mb-1 md:mb-2 text-[#22C55E] uppercase tracking-[0.5px]" data-id="element-95" data-mp="7378lqkatrz5">
          🎁 GRATIS — CON TU MEGAPACK
        </p>
        <p className="font-sans text-[13px] md:text-[16px] leading-[1.5] text-txt-muted" data-id="element-96" data-mp="1z5jmw1vf1j7m">
          Incluidos en tu Megapack, sin costo extra.
        </p>
      </FadeIn>
    </Section>;
};
export const UrgencyCounter = () => {
  const {
    hours,
    minutes,
    seconds,
    isUrgent
  } = useCountdown();
  const accent = isUrgent ? 'text-danger' : 'text-brandGold';
  const boxBorder = isUrgent ? 'border-danger' : 'border-brandGold';
  const boxShadow = isUrgent ? 'shadow-[0_0_25px_rgba(239,68,68,0.45)] animate-red-glow' : 'shadow-[0_0_25px_rgba(212,162,76,0.35)]';
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <section className="bg-bg-base px-4 md:px-6 py-10 md:py-20 overflow-hidden" data-id="element-97" data-mp="11ouflsnp5oqu">
      <div className="max-w-[1100px] mx-auto" data-id="element-98" data-mp="wrb2wx6ndk10">
        <FadeIn className="max-w-3xl mx-auto" data-id="element-99" data-mp="wqj6jk587i9o">
          <div className={`rounded-[20px] border-2 p-6 md:p-10 text-center space-y-6 bg-bg-card max-w-lg mx-auto transition-colors ${isUrgent ? 'border-danger shadow-[0_0_50px_rgba(239,68,68,0.25)]' : 'border-brandGold shadow-[0_0_50px_rgba(212,162,76,0.18)]'}`} data-id="element-100" data-mp="38dmmgo6azyxs">
            <h3 className={`font-sans font-bold uppercase tracking-[1.5px] text-[11px] ${accent}`} data-id="element-101" data-mp="2zbn5twz7awvd">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className={`flex justify-center gap-2.5 md:gap-4 ${isUrgent ? 'animate-red-text-pulse' : ''}`} data-id="element-102" data-mp="3r5xj40ad70ng">
              {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-103" data-mp="3w1cv0motamh8" data-mpi={i}>
                  {i > 0 && <div className={`font-display font-bold text-[34px] md:text-[46px] py-2 flex items-center ${accent}`} data-id="element-104" data-mp="3i3fz7si6mk3m">
                      :
                    </div>}
                  <div className={`bg-bg-card border-2 rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center transition-colors ${boxBorder} ${boxShadow}`} data-id="element-105" data-mp="26oj7gaum5gsk">
                    <div className={`font-display font-bold text-[34px] md:text-[46px] leading-none ${accent}`} data-id="element-106" data-mp="32e7fycoi7k60">
                      {unit.value.toString().padStart(2, '0')}
                    </div>
                    <div className={`font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] mt-1 ${accent}`} data-id="element-107" data-mp="2tchioq7xxr0b">
                      {unit.label}
                    </div>
                  </div>
                </React.Fragment>)}
            </div>

            <div className="flex items-center justify-center gap-2 font-sans font-bold text-base md:text-xl text-gold-bright leading-snug" data-id="element-108" data-mp="3h2v96cavnhss">
              <AlertTriangle size={20} data-id="element-109" data-mp="3cb3im1rq1c2n" />
              <span data-id="element-110" data-mp="3ca24fofes9gp">Después sube el precio. No vuelve.</span>
            </div>

            <div className="p-4 rounded-[14px] border border-line bg-bg-alt" data-id="element-111" data-mp="37cipsnestuo8">
              <div className="flex justify-between font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-body mb-3" data-id="element-112" data-mp="8o3f0y30if8r">
                <span className="flex items-center gap-2" data-id="element-113" data-mp="3v0konqev1ri">
                  <span className="w-2 h-2 rounded-full bg-brandGold animate-pulse" data-id="element-114" data-mp="b89lbcf3mhsh"></span>{' '}
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-brandGold font-bold" data-id="element-115" data-mp="l5noiac0ha2u">Quedan pocos</span>
              </div>
              <div className="w-full bg-line rounded-full h-2 mb-2 overflow-hidden" data-id="element-116" data-mp="l80d36c9yiov">
                <div className="bg-brandGold h-full rounded-full" style={{
                width: '71%'
              }} data-id="element-117" data-mp="q2nw4poiekw2"></div>
              </div>
              <p className="font-sans text-[12px] md:text-[13px] text-txt-muted text-right" data-id="element-118" data-mp="z4ndxk7clt02">
                71% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const Pricing = () => {
  const includes = [{
    icon: '🎬',
    label: 'Curso completo — 15 Módulos en Video HD',
    detail: 'TODO lo que necesitas dominar en un solo lugar',
    price: 'USD $87'
  }, {
    icon: '📚',
    label: '4 Manuales Técnicos Completos',
    detail: '475+ páginas de técnica pura lista para consulta',
    price: 'USD $79'
  }, {
    icon: '🎁',
    label: '5 Bonos Exclusivos',
    detail: 'Cartas de color, fichas, kit de materiales — TODO imprimible',
    price: 'USD $57'
  }];
  return <Section className="bg-bg-alt !pt-6 !pb-8 md:!pt-12 md:!pb-14" id="pricing" data-id="element-119" data-mp="2rcav3unhd56s">
      <div className="max-w-lg mx-auto" data-id="element-120" data-mp="2vdcse5xu7764">
        <FadeIn className="text-center mb-5 md:mb-7" data-id="element-121" data-mp="30b5zr2avm77z">
          <p className="font-sans text-[12.5px] md:text-[15px] text-txt-body" data-id="element-122" data-mp="30acz8j2igdya">
            Estás a un paso de tener TODO organizado y listo para dominar...
          </p>
          <h2 className="font-display font-bold uppercase text-[26px] md:text-[40px] leading-[1.15] tracking-[0.5px] text-txt-primary mt-2 max-w-[18ch] md:max-w-none mx-auto" data-id="element-123" data-mp="3a0fvcs4xi80u">
            OFERTA ESPECIAL DE{' '}
            <span className="text-brandGold" data-id="element-124" data-mp="3j2p174p95d7w">LANZAMIENTO</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-125" data-mp="3o1ieaw0mn27j">
          <div className="relative rounded-[20px] md:rounded-[24px] border-2 border-brandGold bg-bg-card px-4 pt-7 pb-4 md:px-7 md:pt-9 md:pb-6 shadow-[0_0_60px_rgba(212,162,76,0.18)]" data-id="element-126" data-mp="3o0qo60pstwon">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brandGold text-[#14100A] font-sans font-bold uppercase tracking-[1.5px] text-[9.5px] md:text-[11px] px-3 py-1 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(212,162,76,0.45)]" data-id="element-127" data-mp="17chagkg7f2k5">
              ⭐ MÁS ELEGIDO
            </div>

            <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted text-center mb-3 md:mb-4" data-id="element-128" data-mp="1v2tp0e5yfxjp">
              Lo que incluye tu Megapack
            </p>

            <ul className="divide-y divide-line border-y border-line" data-id="element-129" data-mp="1m9goaq1nfrn2">
              {includes.map(item => <li key={item.label} className="flex items-center justify-between gap-3 py-2.5 md:py-3" data-id="element-130" data-mp="1hboutrlcvxgr">
                  <div className="flex items-start gap-2 min-w-0" data-id="element-131" data-mp="2esx3o6yf43pe">
                    <span className="text-[15px] md:text-lg leading-none mt-0.5" aria-hidden="true" data-id="element-132" data-mp="29zuhwkzvtyjr">
                      {item.icon}
                    </span>
                    <div className="min-w-0" data-id="element-133" data-mp="2xw7j8zkiyraz">
                      <p className="font-sans font-bold text-[12.5px] md:text-[15px] text-txt-primary leading-snug" data-id="element-134" data-mp="2xuw7acgxed8s">
                        {item.label}
                      </p>
                      <p className="font-sans text-[10.5px] md:text-[12.5px] leading-[1.35] text-txt-muted" data-id="element-135" data-mp="2o5mcgoup6ggz">
                        {item.detail}
                      </p>
                    </div>
                  </div>
                  <span className="font-sans font-bold text-[12.5px] md:text-[15px] line-through text-danger shrink-0" data-id="element-136" data-mp="2f6itdkvj612h">
                    {item.price}
                  </span>
                </li>)}
            </ul>

            <div className="pt-3 md:pt-4 text-center" data-id="element-137" data-mp="257tnkqgws72l">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted" data-id="element-138" data-mp="3vjpsscm0fxg1">
                Valor original
              </p>
              <p className="font-display font-bold text-[20px] md:text-[26px] leading-none line-through text-danger mt-1" data-id="element-139" data-mp="3du9jxcejbm7">
                USD $223
              </p>
            </div>

            <div className="mt-3 md:mt-4 rounded-[16px] border border-brandGold/30 bg-bg-alt px-4 py-3.5 md:py-5 text-center" data-id="element-140" data-mp="1jujbjseby17w">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandGold" data-id="element-141" data-mp="1sxkgvqvdfoai">
                Acceso completo hoy por
              </p>
              <p className="font-display font-bold text-[42px] md:text-[58px] leading-none text-brandGold mt-1" data-id="element-142" data-mp="27o1h56w9s85t">
                $27{' '}
                <span className="font-sans font-bold text-[14px] md:text-[18px] align-middle" data-id="element-143" data-mp="2gn510d39grld">
                  USD
                </span>
              </p>
              <p className="font-sans font-bold text-[11px] md:text-[13px] text-success mt-2" data-id="element-144" data-mp="2blpiarok2x65">
                87% de descuento — Solo en lanzamiento
              </p>
              <p className="font-sans text-[10.5px] md:text-[13px] text-txt-muted mt-1.5" data-id="element-145" data-mp="hb2hj2umzx7p">
                Pago único · Sin suscripciones · Acceso inmediato
              </p>
            </div>

            <LocalCurrencyNote className="mt-3 md:mt-4" data-id="element-146" data-mp="nopyl9yc7dz0" />

            <div className="mt-4 md:mt-5" data-id="element-147" data-mp="spdp7uinlssp">
              <CTAButton href={PRODUCTS.megapack.checkoutUrl} fullWidth trackingProduct="megapack" onClick={markCheckoutStarted} className="!py-3.5 md:!py-4 !text-[13.5px] md:!text-base" data-id="element-148" data-mp="sqfbkv54e1pq">
                🎨 DOMINA LA COLORIMETRÍA — ACCESO AHORA
              </CTAButton>
              <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 mt-2.5 md:mt-3.5 font-sans text-[10px] md:text-[12.5px] text-txt-muted" data-id="element-149" data-mp="4z02mjiu8m5i">
                <span data-id="element-150" data-mp="9wtb5j7m5s8y">🔒 Pago seguro</span>
                <span data-id="element-151" data-mp="epmdk0fm0ohv">⚡ Acceso en minutos</span>
                <span data-id="element-152" data-mp="erfovt163ww7">🛡️ Garantía 7 días</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};